import { z } from "zod";

export const intIdSchema = z.string().regex(/^[1-9]\d*$/);

export const intIdCodec = <T extends z.ZodType<string, string>>(idSchema: T) =>
  z.codec(z.number().int().positive(), idSchema, {
    decode: (id) => String(id) as z.input<T>,
    encode: (id) => Number(id),
  });
